<template>
  <!--
      	作者：gmshop
      	时间：2020-06-01
      	描述：插件中心-分销-分销商用户-编辑
      -->
  <el-dialog title="编辑" :visible.sync="dialogVisible" @close="cancelFunc" :close-on-click-modal="false" :close-on-press-escape="false" width="50%">
    <el-form :model="formData">
      <el-form-item label="微信昵称" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.nickName" autocomplete="off" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="微信头像" :label-width="formLabelWidth">
        <img v-img-url="formData.avatarUrl" width="50" height="50" />
      </el-form-item>
      <el-form-item label="姓名" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.real_name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.mobile" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="招募总名额" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.partner_total" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="招募剩余名额" :label-width="formLabelWidth">
        <el-input type="text" v-model="formData.partner_num" autocomplete="off"></el-input>
      </el-form-item>


      <el-form-item label="佣金结算类型" :label-width="formLabelWidth">
        <el-radio v-model="formData.ml_type" :label="1">正常结算</el-radio>
        <el-radio v-model="formData.ml_type" :label="2">特殊定向</el-radio>
      </el-form-item>

      <el-form-item label="灵活用工认证" :label-width="formLabelWidth">
        <el-radio v-model="formData.salary_state" :label="2">待认证</el-radio>
        <el-radio v-model="formData.salary_state" :label="1">已认证</el-radio>
      </el-form-item>


      <el-form-item label="运营中心" :label-width="formLabelWidth">
        <el-radio v-model="formData.city_state" :label="2">关闭</el-radio>
        <el-radio v-model="formData.city_state" :label="1">开启</el-radio>
      </el-form-item>


      <el-form-item label="财神有道" :label-width="formLabelWidth">
        <el-radio v-model="formData.god_state" :label="2">关闭</el-radio>
        <el-radio v-model="formData.god_state" :label="1">开启</el-radio>
      </el-form-item>


      <el-form-item label="运营省份："  :label-width="formLabelWidth" prop="province_id">
        <el-select v-model="formData.province_id" clearable>
          <el-option v-for="item in formData.cityList" :value="item.id" :key="item.name" :label="item.name"></el-option>
        </el-select>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelFunc">取 消</el-button>
      <el-button type="primary" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import PlusApi from '@/api/plus.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '100px',
      /*是否显示*/
      dialogVisible: false,
      /*表单数据模型*/
      formData: {}
    };
  },
  props: {
    open_edit: Boolean,
    userModel: Object
  },
  watch: {
    open_edit: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open_edit;
        if (n) {
          this.formData = this.userModel;
        }
      }
    }
  },
  created() {},
  methods: {
    /*修改用户*/
    confirmFunc() {
      let self = this;
      let params ={};
      params.user_id= this.formData.user_id;
      params.real_name=this.formData.real_name;
      params.mobile=this.formData.mobile;
      params.partner_total=this.formData.partner_total;
      params.partner_num=this.formData.partner_num;
      params.ml_type= this.formData.ml_type;
      params.salary_state= this.formData.salary_state;
      params.god_state= this.formData.god_state;

      params.city_state= this.formData.city_state;
      params.province_id= this.formData.province_id;
      PlusApi.agentUserEdit(params, true)
        .then(data => {
          self.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          self.cancelFunc(true);
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    cancelFunc(e) {
      let type='cancel';
      if(e){
        type='success';
      }
      this.$emit('close', {
        type:type
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/agent/user/dialog/Edit.vue